$(function(){
  function sideForm(){
    $('.side-form').toggleClass('side-form_opened');
    $('.side-form__btn-content_close, .side-form__btn-content_open').toggleClass('side-form__btn-content_hide');
    $('.side-form__overlay').toggleClass('side-form__overlay_revealed');
  }
  
  $('.side-form__btn:not(".side-form__btn_link"), .side-form__overlay').click(sideForm);
  
  $('body').keyup(function(e){
    if ($('.side-form_opened').length && e.which == 27){
      sideForm();
    }
  });
  
  
  $('#simply-form').validator().on('submit', function (e) {
    $('#db_send').removeClass("banner-form-hidden-spinner");
    if (e.isDefaultPrevented()) {
      $('#db_send').addClass("banner-form-hidden-spinner");
      return false;
    }else{
     
      $('#db_send').attr('disabled',true);
      $.ajax({
        type: "POST",
        url: $('#simply-form').attr('action'),
        data: $('#simply-form').serialize(),
        dataType: 'json',
        success: function(data){
          
          $('#simply-form').hide();
          $('.side-form__main-title').append('<div class="text-after-sending-form" style="margin-top: 50px;">' + data.txt_end + '</div>');
          $('#simply-form input:not(input[type="radio"]), #simply-form textarea').each(function(){
            $(this).val("");
          });

          $('#simply-form select option').prop("selected", false);

          $('#simply-form input[type="radio"], #simply-form input[type="checkbox"]').prop('checked', false);

          $('#db_send').attr('disabled',false);
          $('#db_send').addClass("banner-form-hidden-spinner");

          setTimeout(function() {

            if ($('.side-form_opened').length){
              sideForm();
            }
            $('.text-after-sending-form').remove();
            $('#simply-form').show();
          }, 6000);
        }
  
      });
      return false;
    }
    return false;
  });
  $('#db_send').on('click',function(){
    if($(this).hasClass("banner-form-hidden-spinner")){
      $(this).removeClass("banner-form-hidden-spinner");
      return true;
    }
    return true;
  });


  function isIEorEDGE(){
    if (navigator.appName == 'Microsoft Internet Explorer'){
      return true; // IE
    }
    else if(navigator.appName == "Netscape"){                       
       return navigator.appVersion.indexOf('Edge') > -1; // EDGE
    }       
  
    return false;
  }
  
  // if(isIEorEDGE()){
  //   $('.side-form__btn').addClass('side-form__btn--edge');
  // }

}); 